























































































































































































































































































































































































































































































































































































































































































































interface curAccount {
    addtax: string;
    accountBookId: number;
    startPeriod: string;
    endPeriod: string;
}
interface tabs {
    text: string;
    tip: string;
    name: string;
    show: boolean;
}

import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import MonthSelectorVue from "../../components/MonthSelector.vue";
import idTypeList from "../../data/idTypeList";
import Country from "./Country";
import AnnuaEITTree, { AnnualTreeList } from "./AnnuaEITTree";
import AnnualEITTreeVue from "./AnnualEITTree.vue";
import { mapGetters } from "vuex";
@Component({
    ...mapGetters(["accountBook"]),
    components: {
        "month-selector": MonthSelectorVue,
        "annual-tree": AnnualEITTreeVue

    }
})
export default class AnnualEITA000000 extends Vue {
    curAccount: curAccount = {
        addtax: this.$store.state.accountBook.addtax,
        accountBookId: this.$store.state.accountBook.id,
        startPeriod: "",
        endPeriod: ""
    };
    treeList: AnnualTreeList[] = [];
    treeLeft: string = "";
    treeTop: string = "";
    activeTab: string = "";
    checkedList: any[] = [];
    is107: boolean = false;
    typeList = idTypeList;
    countryList = Country;
    radio: number = 1;
    checked: boolean = false;
    shareholderList: EITAnnualA000000.shareholderList[] = [];
    row: EITAnnualA000000.EITAnnualA000000 = {
        accountBookId: null,
        changeTypeName: null,
        id: null,
        socialCreditCode: "",
        accountBookName: "",
        startDate: "",
        endDate: "",
        declareDate: "",
        writtenDate: "",
        row101: null,
        row102: null,
        row103: "",
        row104: null,
        row105: null,
        row106: 0,
        row107: "",
        row108: 0,
        row109: 1,
        row110: "",
        row201: null,
        row202: null,
        row203: null,
        row204: null,
        row205: null,
        row206: null,
        row207: null,
        row208: null,
        row209: null,
        row2101: null,
        row2102: null,
        row2103: null,
        row2104: null,
        row2111: null,
        row2112: null,
        row2113: null,
        row2114: null,
        row212: null,
        row213: null,
        row214: null,
        row215: null,
        row216: null,
        row217: null,
        row218: null,
        row219: null,
        row220: null,
        row221: null,
        row222: null,
        row223: null,
        row300: null,
        row3001: null,
        row3002: null,
        row300List: null,
        year: ""
    };

    mounted() {
        this.activeTab = "incomeTaxDeclarationMain";
        document.addEventListener("click", this.clickBody);
    }

    beforeDestroyed() {
        document.removeEventListener("click", this.clickBody);
    }

    clickBody(e: any) {
        if (!e.target.classList.contains("annual-tree") && !e.target.classList.contains("show-tree")) this.activeTree = "";
    }
    // 显示tree
    isCheck: boolean = false //tree是否有多选框
    activeTree: string = ""
    showTree(treeName: string) {
        if (treeName === "107") {
            this.treeList = AnnuaEITTree[0]
            this.isCheck = false
        } else if (treeName === "206") {
            this.treeList = AnnuaEITTree[1]
            this.isCheck = false
        } else if (treeName === "208") {
            this.treeList = AnnuaEITTree[2]
            this.isCheck = false
        } else if (treeName === "213") {
            this.treeList = AnnuaEITTree[3]
            this.isCheck = true
        } else if (treeName === "214") {
            this.treeList = AnnuaEITTree[4]
            this.isCheck = true
        }

        if (this.activeTree === "") {
            this.activeTree = treeName
        } else this.activeTree = "";

        this.$nextTick(() => {
            // @ts-ignore
            if (this.$refs[treeName + "Tree"] && this.row["row" + treeName] !== null) {
                // @ts-ignore
                (<AnnualEITTreeVue>this.$refs[treeName + "Tree"]).setSelectedKeys(this.row["row" + treeName].split(","));
            }
        })

    }
    handleNodeClick(e: any) {
    }
    dateTime: Date = this.getTime(); //选择的时间

    check214(parents: string, text: string) {
        this.row.row214 = text;
        if (this.row.row213 !== null && this.row.row213.toString().includes("100")) {
            this.row.row213 = `100|法律形式改变, ${parents}`;
        } else {
            this.row.row213 = parents;
        }
        this.changeRow("", "row214")
    }
    check213(parents: string, text: string) {
        if (this.row.row213 !== null && this.row.row213 !== "") {
            if (text.includes("100") && !this.row.row213.toString().includes("100")) this.row.row213 += ", 100|法律形式改变";
        } else {
            if (text.includes("100")) this.row.row213 = "100|法律形式改变";
        }
        this.changeRow("", "row213")
    }
    check107(label: string) {
        if (label === "110|一般企业" || label === "200|小企业会计准则" || label === "500|民间非营利组织会计制度") this.row.row107 = label
        else this.$alert("会计信息同“财务会计制度备案”信息不一致");
        this.activeTree = ""
        this.changeRow("", "row107")

    }
    check206(label: string) {
        this.row.row206 = label
        this.activeTree = ""
        this.changeRow("", "row206")
    }
    check208(label: string) {
        this.row.row208 = label
        this.activeTree = ""
        this.changeRow("", "row208")

    }

    created() {
        this.changeDateTime();
    }
    getTime() {
        let year = new Date().getFullYear() - 1;
        let time = year + "01" + "01";
        return this.$utils.strToDate(time);
    }
    // 初始化dateTime
    changeDateTime() {
        this.fetchData();
    }
    // 获取时间范围
    get disabledDate() {
        return {
            disabledDate: (time: Date) => {
                return (
                    time.getFullYear() < new Date().getFullYear() - 4 ||
                    time.getFullYear() > new Date().getFullYear() + 2
                );
            }
        };
    }
    // 获取数据
    rowList: any = {};
    tmpRow110: string[] = [];
    fetchData() {
        let year = this.dateTime.getFullYear().toString();
        Vue.axios
            .get(
                `enterpriseincometaxannualinfo?accountBookId=${this.$store.state.accountBook.id}&year=${year}`
            )
            .then(res => {
                if (res.data.row110) {
                    res.data.row110 = res.data.row110.split(",");
                    this.tmpRow110 = JSON.parse(JSON.stringify(res.data.row110));
                }
                Object.keys(res.data).forEach(attr => {
                    if (attr != "row203" && attr != "row103" && attr != "row104") {
                        if (res.data[attr] === 0) res.data[attr] = false;
                        else if (res.data[attr] === 1) res.data[attr] = true;
                    }
                })
                this.shareholderList = [];
                this.row = res.data;
                this.getList();
            });
    }
    // 切换纳税申报表
    changeType(val: number) {
        if (val === 1) this.fetchData();
        else this.$router.push({ path: "/AnnualEIT" });
    }
    // 详情跳转各个页面
    changeUrl(url: string) { }
    getList() {
        //创建表格数据
        if (this.row.row300List) {
            for (let i = 0; i < this.row.row300List.length; i++) {
                this.shareholderList.push(this.row.row300List[i]);
            }
            if (this.row.row300List.length < 9) {
                let num = 9 - this.row.row300List.length;
                for (let i = 0; i < num; i++) {
                    this.shareholderList.push({
                        name: null,
                        licenseType: null,
                        licenseNo: null,
                        investmentProportion: null,
                        investmentIncome: null,
                        country: null
                    });
                }
            }
        } else {
            for (let i = 0; i < 9; i++) {
                this.shareholderList.push({
                    name: null,
                    licenseType: null,
                    licenseNo: null,
                    investmentProportion: null,
                    investmentIncome: null,
                    country: null
                });
            }
        }
    }
    // 更改行内数据
    changeRow(val: string, name: string) {
        if (name === "row110") {
            let text = (<string[]>this.row.row110).join(",");
            if (this.tmpRow110.join("").includes("否")) {
                if (text.includes("境内") || text.includes("境外")) {
                    this.$alert("110上市公司”在勾选了“境内”或“境外”时，不能再勾选“否”！");
                    this.row.row110 = this.tmpRow110;
                    return
                };
            } else if (text.includes("否")) {
                this.$alert("110上市公司”在勾选了“境内”或“境外”时，不能再勾选“否”！");
                this.row.row110 = this.tmpRow110;
                return
            }
        }
        if (name === "row209") {
            if (this.row.row209) { }
            else this.$alert("209集成电路生产项目类型只有在‘208软件、集成电路企业类型（填写代码）’有值时才允许录入！");
        }
        if (name) {
            this.row.changeTypeName = name;
            let rowCopy = JSON.parse(JSON.stringify(this.row));
            Object.keys(rowCopy).forEach(attr => {
                if (rowCopy[attr] === true) rowCopy[attr] = 1;
                else if (rowCopy[attr] === false) rowCopy[attr] = 0;
            })
            if (rowCopy.row110) rowCopy.row110 = (<string[]>rowCopy.row110).join(",");
            if (rowCopy.row209) rowCopy.row209 = (<string[]>rowCopy.row209).join(",");
            if (rowCopy.row2102) {
                rowCopy.row2102 = this.$utils.simpleDateFormat(
                    new Date(rowCopy.row2102),
                    "d", true
                );
            }
            if (rowCopy.row2104) {
                rowCopy.row2104 = this.$utils.simpleDateFormat(
                    new Date(rowCopy.row2104),
                    "d", true
                );
            }
            if (rowCopy.row2112) {
                rowCopy.row2112 = this.$utils.simpleDateFormat(
                    new Date(rowCopy.row2112),
                    "d", true
                );
            }
            if (rowCopy.row2114) {
                rowCopy.row2114 = this.$utils.simpleDateFormat(
                    new Date(rowCopy.row2114),
                    "d", true
                );
            }
            if (rowCopy.row215) {
                rowCopy.row215 = this.$utils.simpleDateFormat(
                    new Date(rowCopy.row215),
                    "d", true
                );
            }
            Vue.axios
                .post(
                    `enterpriseincometaxannualinfo?accountBookId=${this.$store.state.accountBook.id}&year=${this.dateTime}`,
                    rowCopy
                )
                .then(res => {
                    this.fetchData();
                });
        }
    }
    selectInner(e: any,num?:number) {
        if(num){
           if(num === 103){
            this.$message({
                    type: "warning",
                    message: "资产总额填写全年季度平均值，填报单位是万元，币种为人民币。"
                });
            }else{
                this.$message({
                    type: "warning",
                    message: "提示：从业人数填写全年季度平均值，从业人数必须大于0且为整数。"
                });
            }
        }
        this.$nextTick(() => {
            e.target.select();
        });
	}
	
	blurId = 0;

	focusGudong(e: any, row: any) {
		this.selectInner(e);
		if (row.__ob__.dep.id !== this.blurId && this.blurId !== 0) {
			this.$message.warning("请填写完整的股东信息");
		}
	}
    modifylist(el: any, row: any, name?: string) {
		let isNotNull = this.isNotNull(row);
        let isString = this.isString(row);
		this.row.row300List = [];
		this.blurId = row.__ob__.dep.id;
        if (isNotNull && isString) {
            for (let i = 0; i < this.shareholderList.length; i++) {
                let listNull = this.isNotNull(this.shareholderList[i]);
                if (listNull) {
                    if (this.row) {
                        this.row.row300List.push(this.shareholderList[i]);
                    }
                }
            }
            if (row.licenseNo) {
                if (this.testNo(row.licenseNo)) {
                    this.changeRow("300", "row300");
                }
            }
        } else {
            if (isNotNull) this.$message.warning("请填写完整的股东信息");
        }
    }
    testNo(no: string) {
        const reg = /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/;
        if (!reg.test(no)) {
            this.$message.warning("身份证格式不正确");
            return false;
        }
        return true;
    }
    isNotNull(row: EITAnnualA000000.shareholderList) {
        if (
            row.name != null &&
            row.licenseType != null &&
            row.licenseNo != null &&
            row.investmentProportion != null &&
            row.investmentIncome != null &&
            row.country != null
        )
            return true;
        else return false;
    }
    isString(row: EITAnnualA000000.shareholderList) {
        if (
            row.name != "" &&
            row.licenseType != "" &&
            row.licenseNo != "" &&
            row.investmentProportion != "" &&
            row.investmentIncome != "" &&
            row.country != ""
        )
            return true;
        else return false;
    }
}
